import React from 'react';
import axios from 'axios';
import { get } from 'lodash';
import { API_HOST } from '../../consts';
import PropTypes from 'prop-types';
import { Form } from 'informed';
import Select from 'react-select';
import FormTable from '../../components/FormTable';
import AnaliseReportExportMenu from '../../components/AnaliseReportExportMenu';
import ParametroItem from '../../components/ParametroItem';
import ParametroItemAnalise from '../../components/ParametroItemAnalise';
import { Link } from 'react-router-dom';
import AnaliseDados from './AnaliseDados';

const mapItem = (d) => ({
  value: d.id,
  label: `Item na posição ${d.posicao_atual ? d.posicao_atual : d.posicao_corrigida
    } da avaliação - Código do Item: ${d.id} ${d.alpha > d.alpha_teste ? '🔴' : ''
    }`,
  ...d
});

class AnaliseResumida extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itensAnalise: [],
      className: ''
    };
    this.componentToPrintRef = React.createRef();
  }

  NivelDificuldadeHeaders = ['Dificuldade', 'Mínimo', 'Máximo'];

  NivelDificuldadeData = [
    ['Muito difícil', '0 ', '< 15%'],
    ['Difícil', '15%', '< 35%'],
    ['Médio', '35%', '< 65%'],
    ['Fácil', '65%', '< 85%'],
    ['Muito Fácil', '85%', '< 100%']
  ];

  formatItens = (itens) => {
    return (
      itens &&
      itens.map((item) => {
        const concordancia = () => {
          if (item.nivel_dificuldade === item.dificuldade_name) {
            return 'Sim';
          } else {
            return 'Não';
          }
        };
        return {
          posicao: item.posicao,
          id: item.id,
          acertos: item.dificuldade,
          dificuldade_name: item.dificuldade_name,
          dificuldade_real: item.nivel_dificuldade,
          concordancia_dp_dr: concordancia(),
          nivel_bisserial: item.nivel_bisserial,
          nivel_discriminacao: item.nivel_discriminacao
        };
      })
    );
  };

  formatItensToExport = (itens) => {
    return (
      itens &&
      itens.map((item) => {
        const concordancia = () => {
          if (item.nivel_dificuldade === item.dificuldade_name) {
            return 'Sim';
          } else {
            return 'Não';
          }
        };
        return {
          'Código do Item': item.id,
          posicao: item.posicao,
          acertos: item.dificuldade,
          'Dificuldade Presumida': item.dificuldade_name,
          'Dificuldade Real': item.nivel_dificuldade,
          'Concordância entre Dificuldade presumida e real': concordancia(),
          'Nível Bisserial': item.nivel_bisserial,
          'Nível Discriminacao': item.nivel_discriminacao
        };
      })
    );
  };

  mergeFieldsWithItems(itensWithFields) {
    const { itensAnalise } = this.state;
    let newItens = [];
    itensWithFields.map((item) => {
      itensAnalise.map((oldItem) => {
        if (item.id === oldItem.id) {
          newItens.push({ ...item, ...oldItem });
        }
      });
    });
    this.setState({
      itensAnalise: newItens
    });
  }

  get itensAnalise() {
    const { itens } = this.props;
    return itens.map((item) => this.standarizeItem(item));
  }

  get pageSize() {
    const { itensAnalise } = this.state;
    return itensAnalise.length;
  }

  componentDidUpdate(prevProps) {
    const { itens, parametros } = this.props;
    if (prevProps.itens !== itens || prevProps.parametros !== parametros) {
      const showTable = itens.length && parametros.length;
      if (showTable) {
        this.setState({
          showTable,
          itensAnalise: this.itensAnalise
        });
        this.addItensExtraFields();
      }
    }
  }
  addItensExtraFields() {
    const { itens } = this.props;
    const extraFields = [
      'id',
      'disciplina_name',
      'dificuldade_name',
      'dificuldade',
      'matriz_referencia',
      'habilidade_name',
      'competencias'
    ];
    const itensIds = itens.map((item) => item.id);
    axios
      .get(`${API_HOST}/itens/item/specific_values`, {
        params: {
          itens: itensIds.join(),
          fields: extraFields.join()
        }
      })
      .then((response) => {
        this.mergeFieldsWithItems(response.data);
      });
  }

  standarizeItem = (item) => {
    const { parametros } = this.props;
    const { gabarito } = item;
    const posicao = item.posicao_corrigida - 1;
    const analiseDoItem = parametros[posicao][gabarito];
    return {
      posicao: item.posicao_corrigida,
      id: item.id,
      ...analiseDoItem
    };
  };

  renderAnaliseItemResumido() {
    const { itensAnalise } = this.state;
    const {
      itemSelecionado,
      getItensWithAlpha,
      analiseGrupo,
      renderAnaliseAlternativas,
      itemChange,
      renderItem,
      dificuldade,
      bisserial,
      discriminacao,
      parametrosGabarito
    } = this.props;
    const itemInfos = getItensWithAlpha();
    const selectOptions = itemInfos.map(mapItem);
    const item = this.formatItens(itensAnalise);

    const color = [
      {
        name: 'Muito Fácil',
        min_dificuldade: 85,
        max_dificuldade: 100,
        color: '#52CE50'
      },
      {
        name: 'Fácil',
        min_dificuldade: 65,
        max_dificuldade: 85,
        color: '#267ed1'
      },
      {
        name: 'Médio',
        min_dificuldade: 35,
        max_dificuldade: 65,
        color: '#ff8e2e'
      },
      {
        name: 'Difícil',
        min_dificuldade: 15,
        max_dificuldade: 35,
        color: '#aa3f3e'
      },
      {
        name: 'Muito Difícil',
        min_dificuldade: 0,
        max_dificuldade: 15,
        color: '#8470FF'
      }
    ];

    const itemData = item.filter((d) => d.id === get(itemSelecionado, 'id'))[0];
    const dificuldadeResult = {
      ...itemData,
      dificuldade: color.filter(
        (d) => d.name === get(itemData, 'dificuldade_name')
      )[0]
    };

    if (itemData) {
      return (
        <div className="pt-3 container">
          <Form>
            <Select
              clearable={false}
              placeholder="selecione"
              col="col-sm-6 pl-0"
              label=""
              options={selectOptions}
              onChange={itemChange}
              value={get(itemSelecionado, 'id')}
              field="itens"
            />
          </Form>
          <div className="col-12" style={{ marginTop: '1rem' }}>
            {renderItem}
          </div>
          <hr className="hr-analise" />
          <div className="d-flex row pt-4 mt-4 mb-4 pb-4">
            <div className="col-12 pb-3">
              <p className="azul">
                <b>Análise do item</b>
              </p>
            </div>
            <AnaliseDados
              discriminacao={discriminacao}
              dificuldade={get(itemData, 'dificuldade_name')}
              parametrosGabarito={parametrosGabarito}
              itemData={itemData}
              analiseGrupo={analiseGrupo}
              renderAnaliseAlternativas={renderAnaliseAlternativas}
            />
          </div>
        </div>
      );
    }
  }

  render() {
    const { aplicacoes, itemSelecionado, analise } = this.props;
    const { itensAnalise } = this.state;
    let tipo_avaliacao = '';
    let idAvaliacao = '';
    aplicacoes.forEach((aplicacao) => {
      tipo_avaliacao = JSON.parse(aplicacao.avaliacao.integracao_totvs);
      idAvaliacao = aplicacao.avaliacao.id;
    });

    const itemToExport = this.formatItensToExport(itensAnalise);

    return (
      <div ref={this.componentToPrintRef} style={{ margin: '0' }}>
        <div className="p-3 container d-flex flex-column">
          <div className="d-flex">
            <AnaliseReportExportMenu
              componentToPrint={this.componentToPrintRef}
              dataToExport={itemToExport}
              disablePrint={true}
            />
            <Link
              id="print"
              className="btn btn-white mb-3"
              style={{ width: 'auto', marginLeft: '0.7rem' }}
              to={`/analise/${analise}/analise-pedagogica/${idAvaliacao}/impressao`}
            >
              <i className="fas fa-print" />
            </Link>
          </div>
          {aplicacoes.map((a) => (
            <>
              <div key={a.id} className="d-flex flex-column text-center">
                <span className="span-analise text-center font-weight-bold">
                  ANÁLISE PSICOMÉTRICA E PEDAGÓGICA
                </span>
                <span className="span-analise text-center">{a.nome}</span>
                <span className="span-analise text-center">
                  Tipo de prova: {get(tipo_avaliacao, 'avaliacao', '')}
                </span>
              </div>

              <span className="span-analise">
                Prezada(o) docente, O objetivo desse documento é apresentar o
                desempenho da turma em relação à habilidade requerida em cada
                questão. Além disso, você poderá avaliar o desempenho do item e
                entender se ele conseguiu medir aquilo que se predispôs. As
                informações abaixo deverão ser usadas durante a devolutiva da
                prova e, o mais importante, deverão nortear ações pedagógicas
                futuras.
              </span>

              <span
                className="span-analise font-weight-bold"
                style={{ fontSize: '1.1rem' }}
              >
                Nível de dificuldade da prova
              </span>
              <div className="d-flex flex-column align-items-center">
                <span className="span-analise">
                  Mede o grau de dificuldade do item. É calculado por meio da
                  porcentagem de acerto, quanto menor a porcentagem de acerto
                  maior será o grau de dificuldade.
                </span>
                <div className="mt-1 d-flex flex-column align-items-start">
                  <FormTable
                    headers={this.NivelDificuldadeHeaders}
                    data={this.NivelDificuldadeData}
                  />
                </div>
                <span className="span-analise">
                  De acordo com a literatura, o nível de dificuldade da prova
                  deve ser representado da seguinte forma: 30% itens com
                  dificuldade fácil, 40% itens com dificuldade média e 30% com
                  dificuldade difícil. Veja como foi essa distribuição na prova
                  de sua disciplina:
                </span>

                <div id="dificuldade-resumida-chart" />
                <hr className="hr-analise" />
              </div>

              <div className="d-flex flex-column align-items-start">
                <span
                  className="span-analise font-weight-bold"
                  style={{ fontSize: '1.1rem' }}
                >
                  Nível de discriminação da prova
                </span>
                <span className="span-analise">
                  Mede a capacidade do item de discriminar quem sabe de quem não
                  sabe. É calculado pela diferença entre a proporção de acertos
                  do grupo de participantes com maior habilidade e o grupo com
                  menor habilidade, sendo o grupo de maior habilidade 27% dos
                  respondentes com pontuação mais alta e o de menor habilidade
                  27% dos respondentes com pontuação mais baixa.
                </span>
              </div>

              <div id="discriminacao-resumida-chart" style={{ height: 550 }} />

              <hr className="hr-analise" />

              <span
                className="span-analise font-weight-bold"
                style={{ fontSize: '1.1rem' }}
              >
                Análise dos itens
              </span>

              <hr className="hr-analise" />
              {itemSelecionado && this.renderAnaliseItemResumido()}
            </>
          ))}
        </div>
      </div>
    );
  }
}

AnaliseResumida.propTypes = {
  itens: PropTypes.array,
  parametros: PropTypes.array
};

AnaliseResumida.defaultProps = {
  itens: [],
  parametros: []
};

export default AnaliseResumida;
